export const common = {
  add: 'Agregar',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  clear: 'Limpiar',
  close: 'Cerrar',
  comingSoon: 'Próximamente...',
  confirm: 'Confirmar',
  create: 'Crear',
  creating: 'Creando...',
  dateFormatLocale: 'es-ES',
  datePicker: {
    placeholder: 'Seleccionar fecha',
  },
  dateRangePicker: {
    presets: {
      last7Days: 'Últimos 7 días',
      last30Days: 'Últimos 30 días',
      last90Days: 'Últimos 90 días',
      lastMonth: 'Mes pasado',
      monthToDate: 'Mes en curso',
      yearToDate: 'Año en curso',
      custom: 'Custom',
    },
    sections: {
      dateRange: 'Rango de fechas',
      compareTo: 'Comparar con',
      format: 'Formato',
    },
    compare: {
      previousPeriod: 'Período anterior',
      previousMonth: 'Mismo período mes anterior',
      previousYear: 'Mismo período año anterior',
      custom: 'Personalizado',
      goal: 'Objetivo',
      none: 'Sin comparación',
    },
    format: {
      percentage: 'Cambio porcentual',
      absolute: 'Cambio absoluto',
    },
    from: 'Desde',
    to: 'Hasta',
    triggerCompare: 'vs {{label}}',
    editingRange: 'Elegí el rango de fechas en el calendario',
    editingCompare: 'Elegí el rango de comparación en el calendario',
  },
  delete: 'Eliminar',
  deleting: 'Eliminando...',
  edit: 'Editar',
  error: 'Error',
  errorOccurred: 'Se produjo un error',
  errors: {
    emailValidation: {
      alreadyTaken: 'El correo electrónico ya está en uso',
      invalid: 'El formato del correo electrónico es inválido',
      validationError: 'Error al validar el correo electrónico',
    },
  },
  form: {
    fields: {
      birthdate: {
        error: {
          future: 'La fecha de nacimiento no puede ser en el futuro',
          invalid: 'Formato de fecha inválido',
          tooOld: 'La fecha de nacimiento parece muy antigua',
        },
        label: 'Fecha de Nacimiento',
        placeholder: 'Seleccionar fecha de nacimiento',
      },
      email: {
        error: {
          required: 'El correo electrónico es requerido',
        },
        label: 'Correo electrónico',
        placeholder: 'juan.perez@ejemplo.com',
      },
      gender: {
        female: 'Femenino',
        label: 'Género',
        male: 'Masculino',
        other: 'Otro',
        placeholder: 'Seleccionar género',
      },
      image: {
        help: 'URL de la imagen',
        label: 'URL de Imagen',
        placeholder: 'https://ejemplo.com/imagen.jpg',
      },
      lang: {
        english: 'Inglés',
        label: 'Idioma',
        placeholder: 'Seleccionar idioma',
        portuguese: 'Portugués',
        spanish: 'Español',
      },
      password: {
        editPlaceholder: 'Haz clic en regenerar para modificar la contraseña',
        error: {
          invalid: 'Contraseña inválida',
          mustCopy: 'Debes copiar la contraseña para continuar',
          required: 'La contraseña es requerida',
        },
        label: 'Contraseña',
        placeholder: 'Ingresa la contraseña',
      },
      phone: {
        label: 'Número de Teléfono',
        placeholder: 'Ingresa un número de teléfono',
      },
      role: {
        label: 'Rol en la aplicación',
        placeholder: 'Seleccionar un rol',
        required: 'El rol es requerido',
      },
      timezone: {
        detecting: 'Detectando zona horaria...',
        emptyMessage: 'No se encontró zona horaria.',
        placeholder: 'Seleccionar zona horaria',
        searchPlaceholder: 'Buscar zona horaria...',
      },
    },
  },
  back: 'Volver',
  goBack: 'Volver',
  goHome: 'Ir al Inicio',
  language: {
    iso: {
      en: 'Inglés',
      es: 'Español',
      pt: 'Portugués',
      unknown: 'Desconocido',
    },
  },
  loading: 'Cargando...',
  optional: 'Opcional',
  refresh: 'Actualizar',
  refreshing: 'Actualizando...',
  restore: 'Restaurar',
  roles: {
    admin: 'Administrador',
    manager: 'Líder de Equipo',
    member: 'Colaborador',
    owner: 'Propietario',
    viewer: 'Observador',
    superadmin: 'Super Administrador',
  },
  retry: 'Reintentar',
  save: 'Guardar',
  saving: 'Guardando...',
  showLess: 'Ver Menos',
  showMore: 'Ver Más',
  tags: {
    addTag: 'Agregar Etiqueta',
    availableTags: 'Etiquetas Disponibles',
    createError: 'Error al crear etiqueta',
    createSuccess: 'Etiqueta creada correctamente',
    createTag: 'Crear "{{tag}}"',
    errorLoadingTags: 'Error al cargar etiquetas',
    manageTags: 'Gestionar Etiquetas',
    noTagsFound: 'No se encontraron etiquetas',
    searchPlaceholder: 'Buscar etiqueta...',
  },
  tryAgain: 'Intentar de nuevo',
  unexpectedError: 'Error inesperado',
} as const
